<div class="card-property" [style.width]="cardPropertyData().propertyWidth">
  <!-- card property icon -->
  <div class="card-property__icon">
    @if (cardPropertyData().iconIsSvg && cardPropertyData().icon) {
      <img
        class="icon-img"
        [ngSrc]="cardPropertyData().icon"
        width="10"
        height="10"
        alt="verify" />
    } @else {
      <i
        class="iconsax icon-element"
        [ngClass]="cardPropertyData().iconClasses"
        [attr.icon-name]="cardPropertyData().icon"></i>
    }
  </div>

  <!-- card property content -->
  <div class="card-property__content">
    <h3 class="property-name">{{ cardPropertyData().name | translate }}</h3>
    <div class="property-value" [ngClass]="cardPropertyData().valueClasses">
      <pwj-text-summarizer
        [limitLength]="cardPropertyData()?.summarizeLength || 14"
        [text]="
          cardPropertyData().isI18nValueType
            ? (cardPropertyData().value | translateData)
            : (cardPropertyData().value.toString() | translate)
        "></pwj-text-summarizer>

      <i
        class="iconsax mx-2"
        [ngClass]="cardPropertyData().valueIconClasses"
        [attr.icon-name]="cardPropertyData().propertyValueIcon"></i>
    </div>
  </div>
</div>
